import { TeContainer, TeIcon, TeText } from '@topcon/tuicl-react';

interface Props {
  /** e.g. "No close matches found." — already translated. */
  title: string;
  /** Scope-specific follow-up telling the user what to do instead. */
  description: string;
}

/**
 * Shown in a Review modal when the candidate has no Potential Matches at all.
 * Shared by the identity-scope and dealer-scope Review modals; only the copy
 * differs between them.
 */
function NoMatchesEmptyState({ title, description }: Props) {
  return (
    <TeContainer
      backgroundColor="background.secondary"
      borderColor="border.secondary"
      borderRadius="l"
      column
      alignItems="center"
      justifyContent="center"
      gap="xs"
      padding="xl"
      height="auto"
      fill
      data-testid="no-matches-empty-state"
    >
      <TeIcon name="domain_disabled" size="xl" color="icon.muted" />
      <TeText size={14} color="text.placeholder" alignment="center">
        {title}
      </TeText>
      <TeText size={14} color="text.secondary" alignment="center">
        {description}
      </TeText>
    </TeContainer>
  );
}

export default NoMatchesEmptyState;
